module.exports = __webpack_public_path__ + "static/media/trocafone-logo.3096c684.png";